import React from 'react';
import styled from '@emotion/styled';

const SkipLinkContainer = styled.a`
  position: absolute;
  top: -40px;
  left: 6px;
  background: #000;
  color: #fff;
  padding: 8px;
  text-decoration: none;
  border-radius: 4px;
  z-index: 9999;
  font-weight: bold;
  
  &:focus {
    top: 6px;
    outline: 2px solid #4A90E2;
    outline-offset: 2px;
  }
`;

type SkipLinkProps = {
  href: string;
  children: React.ReactNode;
};

const SkipLink = ({ href, children }: SkipLinkProps) => {
  return (
    <SkipLinkContainer href={href}>
      {children}
    </SkipLinkContainer>
  );
};

export default SkipLink;
